import React from 'react';
import PropTypes from 'prop-types';
import { childNodes } from 'Helpers/PropTypes';
import classNames from 'classnames';
import Portal from '@material-ui/core/Portal';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useOnboardingFooter } from '../../../Contexts/OnboardingFooterContext';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
  },
});

const SurveyFixedFooterActions = ({
  className,
  classes,
  children,
}) => {
  const { footerRef } = useOnboardingFooter();

  return (
    <Portal container={footerRef.current}>
      <Box
        className={classNames(classes.root, className)}
      >
        {children}
      </Box>
    </Portal>
  );
};

SurveyFixedFooterActions.defaultProps = {
  children: null,
  className: '',
};

SurveyFixedFooterActions.propTypes = {
  children: childNodes,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SurveyFixedFooterActions);
